import { render, staticRenderFns } from "./cultrue1.vue?vue&type=template&id=1adced4e&scoped=true"
import script from "./cultrue1.vue?vue&type=script&lang=js"
export * from "./cultrue1.vue?vue&type=script&lang=js"
import style0 from "./cultrue1.vue?vue&type=style&index=0&id=1adced4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adced4e",
  null
  
)

export default component.exports